import axios from '../utils/axios';
import Constants from './types';
import { getSessionId, getPayloadFromError } from '../utils';

export const assignGlobalIdentifiers = entityId => {
  const sessionId = getSessionId();
  const params = {
    entityId: entityId
  };
  return dispatch => {
    axios({
      method: 'PUT',
      url: '/openempi-ws-rest/1.0/records/global-identifiers',
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params
    })
      .then(res => {
        dispatch(assignGlobalIdentifiersSuccess(res.data));
      })
      .catch(err => {
        dispatch(assignGlobalIdentifiersFailure(err));
      });
  };
};

export const removeGlobalIdentifiers = entityId => {
  const sessionId = getSessionId();
  const params = {
    entityId: entityId
  };
  return dispatch => {
    axios({
      method: 'DELETE',
      url: '/openempi-ws-rest/1.0/records/global-identifiers',
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params
    })
      .then(res => {
        dispatch(removeGlobalIdentifiersSuccess(res.data));
      })
      .catch(err => {
        dispatch(removeGlobalIdentifiersFailure(err));
      });
  };
};

export const createEntityIndexes = entityId => {
  const sessionId = getSessionId();
  const url = `/openempi-ws-rest/1.0/entities/${entityId}/indexes`;
  return dispatch => {
    axios({
      method: 'POST',
      url,
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      }
    })
      .then(res => {
        dispatch(createEntityIndexesSuccess(res.data));
      })
      .catch(err => {
        dispatch(createEntityIndexesFailure(err));
      });
  };
};

export const dropEntityIndexes = entityId => {
  const sessionId = getSessionId();
  const url = `/openempi-ws-rest/1.0/entities/${entityId}/indexes`;
  return dispatch => {
    axios({
      method: 'DELETE',
      url,
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      }
    })
      .then(res => {
        dispatch(dropEntityIndexesSuccess(res.data));
      })
      .catch(err => {
        dispatch(dropEntityIndexesFailure(err));
      });
  };
};

export const startPixPdqServer = entityId => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'PUT',
      url: '/openempi-ws-rest/1.0/pixpdq-service/state/up',
      headers: {
        Accept: 'text/plain',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      }
    })
      .then(res => {
        dispatch(startPixPdqServerSuccess(res.data));
      })
      .catch(err => {
        dispatch(startPixPdqServerFailure(err));
      });
  };
};

export const stopPixPdqServer = entityId => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'PUT',
      url: '/openempi-ws-rest/1.0/pixpdq-service/state/down',
      headers: {
        Accept: 'text/plain',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      }
    })
      .then(res => {
        dispatch(stopPixPdqServerSuccess(res.data));
      })
      .catch(err => {
        dispatch(stopPixPdqServerFailure(err));
      });
  };
};

export const clearOperationsError = () => {
  return {
    type: Constants.OPERATIONS_CLEAR_ERROR
  };
};

const assignGlobalIdentifiersSuccess = data => {
  return {
    type: Constants.OPERATION_ASSIGN_GLOBALID_SUCCESS,
    payload: data
  };
};

const assignGlobalIdentifiersFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.OPERATION_ASSIGN_GLOBALID_FAILURE,
    payload
  };
};

const createEntityIndexesSuccess = data => {
  return {
    type: Constants.OPERATION_CREATE_ENTITYINDXS_SUCCESS,
    payload: data
  };
};

const createEntityIndexesFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.OPERATION_CREATE_ENTITYIDXS_FAILURE,
    payload
  };
};

const dropEntityIndexesSuccess = data => {
  return {
    type: Constants.OPERATION_DROP_ENTITYINDXS_SUCCESS,
    payload: data
  };
};

const dropEntityIndexesFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.OPERATION_DROP_ENTITYIDXS_FAILURE,
    payload
  };
};

const removeGlobalIdentifiersSuccess = data => {
  return {
    type: Constants.OPERATION_REMOVE_GLOBALID_SUCCESS,
    payload: data
  };
};

const removeGlobalIdentifiersFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.OPERATION_REMOVE_GLOBALID_FAILURE,
    payload
  };
};

const startPixPdqServerSuccess = data => {
  return {
    type: Constants.OPERATION_START_PIXPDQ_SUCCESS,
    payload: data
  };
};

const startPixPdqServerFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.OPERATION_START_PIXPDQ_FAILURE,
    payload
  };
};

const stopPixPdqServerSuccess = data => {
  return {
    type: Constants.OPERATION_STOP_PIXPDQ_SUCCESS,
    payload: data
  };
};

const stopPixPdqServerFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.OPERATION_STOP_PIXPDQ_FAILURE,
    payload
  };
};
